import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api'

export const useCustomerData = (customerId: string | undefined) => {
  const customerQuery = useQuery(
    dashboardv99990101Client.getCustomer,
    { id: customerId ?? '' },
    { enabled: !!customerId }
  )

  return {
    // Normalise the query's `Customer | null | undefined` to `Customer | undefined`
    // so consumers can type the customer as optional rather than nullable.
    // A failed getCustomer (deleted/inaccessible customer, transient 5xx) also
    // lands here as `undefined`: we deliberately degrade to the no-customer
    // rendering (fallback icon, un-prefixed title) rather than surface an error,
    // since the notification stays fully readable and dismissable without it.
    customer: customerQuery.data ?? undefined,
    // Only pending when there is actually a customer to load — notifications
    // without a customerId must not wait on this query.
    isPending: !!customerId && customerQuery.isPending
  }
}
